class QsM {
  
    constructor(paramMap) {
      this.params = [];
      this.paramMap = paramMap;
      return this;
    }
  
    addParams(params) {
      for (const param of params) {
        this.params.push({ 
          paramName: param.paramName, 
          paramValue: param.paramValue, 
          prevValue: param.prevValue
        });
      }
      return this;
    }
  
    addFilters(filters) {
      this.filters = filters;
      return this;
    }
  
    doUpdate() {
      const hist = window.history;
      if (hist && hist.pushState) {
        const url = new URL(window.location);
        const currentState = Object.assign({}, this.filters);
        const newState = Object.assign({}, this.filters);
        this.params.forEach(param => {
          url.searchParams.set(param.paramName, param.paramValue);
          if (param.prevValue) {
            currentState[param.paramName] = param.prevValue;
          }
          if (this.paramMap.hasOwnProperty(param.paramName)) {
            newState[this.paramMap[param.paramName]] = param.paramValue;
          } else {
            newState[param.paramName] = param.paramValue;
          }
        });
        history.replaceState(currentState, '');
        hist.pushState(newState, '', url);
      }
    }
  }
  
  export { QsM };
  
  const qstr = name => new URL(window.location).searchParams.get(name);

  /**
   * Converts any value to a boolean by converting it to a string, replacing
   * any whitespace, lowercasing it, and testing it with /^(true|1|yes|y)$/i.
   * @param {any} value 
   * @returns Boolean
   */
  const parseBoolean = (value) => /^(true|1|yes|y)$/i.test(('' + value).replace(/\s+/g,'').toLowerCase());
  
  export { qstr, parseBoolean };